import apiClient from '@/plugins/axios';

export default {
	getRoundPlannings(params, opts = {}) {
		if (params.currentPage) params.pageNumber = params.currentPage;

		return apiClient.get('v1/RoundPlanning', { params, ...opts });
	},

	getRoundPlanning(roundPlanningId) {
		return apiClient.get(`v1/RoundPlanning/${roundPlanningId}`);
	},

	getRoundStatistics(params) {
		return apiClient.get('v1/RoundPlanning/roundStatistics', { params });
	},

	createRoundPlanning(roundPlanning) {
		return apiClient.post('v1/RoundPlanning', roundPlanning);
	},

	updateRoundPlanning(roundPlanning) {
		var roundPlanningId = roundPlanning.id;

		return apiClient.put(`v1/RoundPlanning/${roundPlanningId}`, roundPlanning);
	},

	deleteRoundPlanning(roundPlanningId) {
		return apiClient.delete(`v1/RoundPlanning/${roundPlanningId}`);
	},

	triggerRoundMail(roundId) {
		return apiClient.get(`v1/RoundPlanning/sendMail/${roundId}`);
	}
};
